var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconScore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48.9,
    height: 45.761,
    viewBox: "0 0 48.9 45.761",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_Score",
    transform: "translate(213.15 3580.643)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_979",
    "data-name": "Tracciato 979",
    d: "M26.8,0,10.025,3.161.291,24.336l7.4,13.255L26.8,45.761,43.6,39.519l5.595-16.794-6-16.385Z",
    transform: "translate(-163.958 -3534.883) rotate(180)",
    fill: "#881840"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_730",
    "data-name": "Raggruppa 730",
    transform: "translate(2.695 2.506)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1164",
    "data-name": "Tracciato 1164",
    d: "M721.711,588.595l-3.6,3.9-3.122-4.291,3.6-3.9Z",
    transform: "translate(-915.346 -4146.02)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1165",
    "data-name": "Tracciato 1165",
    d: "M731.734,588.2l-3.114,4.3-3.608-3.892,3.114-4.3Z",
    transform: "translate(-917.209 -4146.019)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1166",
    "data-name": "Tracciato 1166",
    d: "M726.721,597.242l-3.643,3.859L720,596.777l3.643-3.859Z",
    transform: "translate(-916.278 -4147.62)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1167",
    "data-name": "Tracciato 1167",
    d: "M737.152,580.352l-3.682,3.821-3.031-4.356L734.121,576Z",
    transform: "translate(-918.217 -4144.476)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1168",
    "data-name": "Tracciato 1168",
    d: "M716.393,579.887l-3.123,4.29-3.6-3.9,3.122-4.291Z",
    transform: "translate(-914.359 -4144.474)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1169",
    "data-name": "Tracciato 1169",
    d: "M726.719,579.812l-3.024,4.36-3.688-3.815L723.031,576Z",
    transform: "translate(-916.279 -4144.476)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconScore);
export default __webpack_public_path__ + "static/media/Icon_Score.56d793bf9a25d86f1c4d911fdd21e0f0.svg";
export { ForwardRef as ReactComponent };